<template>
  <header v-if="userData" class="header--wrap" :class="{'report__header': isReport}">
    <div>
      <slot/>
      <div class="header">
        <slot name="extra"/>

        <div class="btn__area clearfix">

          <slot name="buttons"/>

          <battery-indicator
            :isReport="isReport"
            :description="pvDescription"/>

<!--          <ui-button class="charge-pv"-->
<!--                     v-if="canChargePv && creditData.percentage <= 30"-->
<!--                     :backgroundColor="'#1199af'"-->
<!--                     :primary4="true"-->
<!--                     :size="'small'"-->
<!--                     :iconName="'icon&#45;&#45;pv-plug'"-->
<!--                     @click="onChargePv">-->
<!--            {{ $t('common.chargePv') }}-->
<!--          </ui-button>-->

          <a href="#" class="btn__gnb" @click.stop.prevent="toggleUserMenu">
            <i class="icon icon--user"></i>
          </a>

          <!-- user depth menu -->
          <div class="gnb__navigation" v-if="showUserMenu">
            <div class="home" @click="goBridge">
              <div class="home__icon" />
              <span class="home__text">Home</span>
            </div>
            <div class="user-name">
              <span>{{ userData.userId }}</span>
              <router-link to="/user/myinformation">
                <i class="icon icon--setting"/>
              </router-link>
            </div>
            <ul>
              <li class="item__title">
                <span>UX Heatmap</span>
              </li>
              <li v-for="(item, index) in myInfoPage" :key="index">
                <router-link :to="{ name: item }" class="item item__link">{{ $t(`userInfo.lnb.${item}`) }}</router-link>
              </li>
              <template v-if="userData.isGmc">
                <li class="item--common">
                  <router-link to="/user/jam" class="item item__link">{{ $t(`userInfo.lnb.jam`) }}</router-link>
                </li>
              </template>
              <li class="item__myinformation">
                <router-link to="/user/myinformation" class="item item__link">{{ $t(`userInfo.lnb.myInformation`) }}</router-link>
              </li>
              <li class="item__signout"><a href="#" class="item signout"
                @click.prevent="onSignOutClick">{{ $t('gnb.user.logout') }}</a></li>
              <li class="item__language">
                <span class="item item-language" @click.stop.prevent="showLanguageList(false)">{{ $t('gnb.user.language') }}</span>
                <div class="language--wrap">
                  <span class="current-language" @click.stop.prevent="showLanguageList(true)">
                    <i class="icon icon--lang" :class="currentLocale"></i>
                    {{ currentLocale.toUpperCase() }}
                  </span>
                  <i class="icon icon--drop-down"></i>
                  <transition name="slide">
                    <ul class="language__list" :class="{'is-show': showLanguageListStatus}" v-show="showLanguageListStatus">
                      <li v-for="item in localeData" :key="item.code"
                          :class="{ [item.code]: true, on: item.code === currentLocale }"
                          :title="item.title"
                          @click="onLocaleClick(item.code)">
                        <i class="icon icon--lang" :class="item.code"></i> {{ item.code.toUpperCase() }}
                      </li>
                    </ul>
                  </transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <BreadCrumb v-if="isReport" />
    </div>
  </header>
</template>

<script>
import { SIGNIN_LINK } from '@/libs/constants'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { changeLocale } from '@/libs/i18n'
import { EventBus } from '@/libs/event-bus'
import BatteryIndicator from './BatteryIndicator'
import BreadCrumb from './BreadCrumb.vue'

export default {
  name: 'AppHeader',
  components: {
    BatteryIndicator,
    BreadCrumb
  },
  props: {
    isReport: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      showLanguageListStatus: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showUserMenu'
    ]),
    ...mapGetters([
      'creditData'
    ]),
    isShowUiChanger () {
      const routeName = this.$route.name

      if (['page-add', 'page-edit'].includes(routeName)) {
        return false
      }
      return true
    },
    myInfoPage () {
      if (this.userData.isGmc) {
        return [
          'managePlan',
          'requestManagement',
          'userManagement',
          'pageManagement',
          'ipBlocking'
        ]
      } else {
        return [
          'ipBlocking'
        ]
      }
    },
    currentLocale () {
      return this.$i18n.locale
    },
    pvDescription () {
      if (!this.creditData.hasPlan) {
        return this.$t('gnb.battery.noUsingPlan')
      } else if (this.creditData.isUnlimited) {
        return this.$t('gnb.battery.noLimit')
      } else if (!this.creditData.remain) {
        return this.$t('gnb.battery.empty')
      } else {
        return this.$t('gnb.battery.available', {
          pv: this.$options.filters.thousand(this.creditData.remain)
        })
      }
    },
    canChargePv () {
      if (this.planData.isTerminated || this.planData.isTrial ||
        this.planData.isTrialOver || this.planData.isUnpaid ||
        !this.planData.hasPlan || this.planData.useCoupon) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.localeData = [
      {
        code: 'ja',
        title: 'Japanese'
      },
      {
        code: 'en',
        title: 'English'
      },
      {
        code: 'ko',
        title: 'Korean'
      }
    ]
  },
  mounted () {
    EventBus.$on('closeUserMenu', () => {
      this.setShowUserMenu(false)
      this.showLanguageListStatus = false
    })
  },
  methods: {
    ...mapMutations([
      'setShowUserMenu',
      'clearAllUserData'
    ]),
    toggleUserMenu () {
      EventBus.$emit('closeAllUiSelectBox')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      EventBus.$emit('closeReportPageList')
      this.setShowUserMenu(!this.showUserMenu)
      this.showLanguageListStatus = false
    },
    onLocaleClick (locale) {
      changeLocale(this.$i18n, locale)
    },
    showLanguageList (status) {
      status ? this.showLanguageListStatus = true : this.showLanguageListStatus = false
    },
    onChargePv () {
      if (this.$route.name === 'managePlan') {
        EventBus.$emit('onActionTrigger', 'chargePv')
      } else {
        this.$router.push({ name: 'managePlan', params: { action: 'chargePv' } })
      }
    },
    onSignOutClick () {
      this.$root.$children[0].signOut()
      window.location.href = SIGNIN_LINK
    },
    goBridge () {
      window.location.href = SIGNIN_LINK.replace('signin', 'my')
    }
  }
}
</script>

<style lang="scss">
.header--wrap {
  .header {
    position: relative;
    z-index: 12;
    height: 40px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid rgba(215, 215, 215, 0.52);
    padding-left: 30px;
  }

  .btn__area {
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);

    .ui-change--wrap {
      display: inline-block;
      position: relative;
      top: 1px;

      .label {
        font-size: 12px;
        font-weight: bold;
        color: #444444;
        margin-right: 10px;
      }

      .ui_select {
        vertical-align: middle;
        margin-right: 30px;

        &:after {
          content: '';
          display: inline-block;
          position: absolute;
          top: calc(50% - 2px);
          right: 15px;
          transform: translateY(-50%);
          width: 1px;
          height: 14px;
        }
        .item--wrap {
          height: 30px;
          padding-left: 8px;

          .item__list-item {
            font-size: 13px;
          }
        }
        .selected-item {
          line-height: 28px;
          font-size: 13px;

          .icon {
            width: 12px;
            height: 12px;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .btn_sitelist {
    display: inline-block;
    height: 20px;
    padding: 0 30px 0 31px;
    position: relative;
    top: 1px;
  }

  .gnb__navigation {
    position: absolute;
    top: 34px;
    right: 0px;
    z-index: 10000001;
    width: 220px;
    border-radius: 14px;
    box-shadow: 0 16px 15px -4px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    padding-bottom: 12px;

    .home {
      display: flex;
      align-items: center;
      column-gap: 5px;

      padding-top: 15px;
      padding-left: 20px;

      cursor: pointer;

      &__icon {
        box-sizing: border-box;
        width: 34px;
        height: 34px;
        padding: 9px;
        border-radius: 20px;
        border: solid 1px #bbb;
        background: url(../../assets/img/icon-home.svg) no-repeat center center;
        background-color: #fff;
      }

      &__text {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #2f2f2f;
      }
    }

    .user-name {
      display: flex;
      column-gap: 5px;
      padding-top: 15px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 12px;

      span {
        word-break: break-all;
        max-width: 100%;
        color: #3096a7;
        font-size: 13px;
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.62;
      }

      .icon--setting {
        margin-top: 2.5px;
      }
    }

    & > ul {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;

      li {
        height: 40px;
        padding: 7px 10px;
        box-sizing: border-box;
        position: relative;

        &.item__title {
          height: auto;
          padding-top: 20px;
          border-top: 1px solid #d7d7d7;

          font-size: 12px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          color: #999;
        }

        &.item__signout {
          height: auto;
          padding-top: 15px;
          padding-bottom: 0px;
          border-top: 1px solid #d7d7d7;
        }

        &.item__language {
          display: flex;
          align-items: center;
          height: 50px;
          padding: 12px 0px 0px 0px;
        }

        .item {
          display: inline-block;
          width: 100%;
          height: 27px;
          line-height: 27px;
          font-size: 14px;
          color: #2f2f2f;
          padding-left: 10px;
          box-sizing: border-box;
          border-radius: 12px;
        }

        &:hover .item:not(.item-language):not(.signout) {
          background-color: #ebebeb;
        }

        &.item--common {
          padding: 0;
          padding-top: 7px;
          margin: 7px 10px;
          margin-bottom:0;
          border-top: 1px dashed #d1d1d1;
        }

        &.item__myinformation {
          margin-bottom: 7px;
        }

        .signout {
          display: block;
          margin: 0 auto;
          width: 180px;
          height: 34px;
          border-radius: 20px;
          border: solid 1px #bbbbbb;
          background-color: #ffffff;
          padding-left: 0;
          text-align: center;
          line-height: 32px;
        }

        .language--wrap {
          position: absolute;
          top: 12px;
          right: 0;
          width: 98px;
          height: 38px;
          border-radius: 6px;
          border: solid 1px #bbbbbb;
          background-color: #ffffff;
          box-sizing: border-box;

          .current-language,
          .language__list li{
            display: inline-block;
            width: 100%;
            height: 100%;
            line-height: 36px;
            padding-left: 6px;
            box-sizing: border-box;

            font-size: 14px;
            color: #2f2f2f;
            cursor: pointer;

            .icon--lang {
              vertical-align: middle;
              margin-right: 5px;
              position: relative;
              top: -1px;
            }
          }

          .language__list {
            width: 98px;
            border-radius: 6px;
            box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.25);
            background-color: #ffffff;
            overflow: hidden;
            position: absolute;
            top: -1px;
            left: -1px;
            z-index: 1;

            opacity: 0;
            transform-origin: top;
            transition: transform .2s ease, opacity .1s ease;

            &.is-show {
              opacity: 1;
            }

            li:hover {
              background-color: #ebebeb;
            }
          }

          .icon--drop-down {
            pointer-events: none;
            position: absolute;
            top: 50%;
            right: 12px;
            transform: translateY(-50%);
          }

          .slide-enter, .slide-leave-to{
            transform: scaleY(0);
            opacity: 0;
          }
        }
      }
    }
  }

  .btn__gnb {
    display: inline-block;
    position: relative;
    vertical-align: middle;

    i {
      position: relative;

      &:hover:after {
        @include positionXYcenter;
        display: block;
        content: '';
        width: 30px;
        height: 30px;
        background-color: #000;
        opacity: 0.06;
        border-radius: 50%;
      }
    }
  }

  /* dashboard header */
  &:not(.report__header) {
    width: 100%;
    position: relative;
    z-index: 2;
    .header {
      background-color: transparent;
      border-bottom: none;
      padding: 0;
    }
    .icon--user {
      margin-right: 0px;
    }
  }

  button.charge-pv {
    margin-top: -2px;
    margin-left: 12px;
    transform: translateY(1px);
  }
}

.page_layout {
  .header--wrap {
    .header {
      height: 46px;
    }
  }
  .btn__area {
    padding-top: 1px;
  }
}
</style>
